import { apiTypes }               from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'blemarks',
  title: 'BLE-метки',
  apiType: apiTypes.ALT_NAV_API,
  elemsOnPage: 100,
  connections: {
    blemarkstypes: {
      apiType: apiTypes.ALT_NAV_API,
      table: 'ble_devices_type',
      fields: ['name_type'],
      format: (elem: any) => elem['name_type'],
      index: 'id',
      autocomplete: true,
    },
    blemarksidentifierregistry: {
      apiType: apiTypes.ALT_NAV_API,
      table: 'ble_devices',
      fields: ['serial_number'],
      format: (elem: any) => elem['serial_number'],
      index: 'id',
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'serial_number',
      title: 'Серийный номер',
      type: 'text',
      required: true,
      connection: 'blemarksidentifierregistry',
    },
    {
      name: 'name_type',
      title: 'Тип',
      type: 'text',
      required: true,
      connection: 'blemarkstypes',
    },
    {
      title: 'Координаты',
      type: 'composite',
      name: 'coords',
      disableSort: true,
      disableFilter: true,
      required: true,
      composite: {
        type: 'point_coords',
        accuracy: 6,
        field: 'coords',
        isCoordsArray: true,
      },
      width: '200px'
    },
  ],
  newTemplate: {
    serial_number: null,
    name_type: '',
    coords: null,
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'id',
        field: 'id'
      },
      {
        title: 'serial_number',
        field: 'serial_number'
      },
      {
        title: 'name_type',
        field: 'name_type'
      },
      {
        title: 'coords',
        field: 'coords'
      },
    ],
    example: `1;123;Тип 1;null`
  }
};

export default config;